const chatActions   = require('./chat-actions')
const chatUi        = require('./chat-ui')
const chatNetwork   = require('./chat-network')
const settings      = require('../../js-handler/settings')

export function load(data) {
    let rows;
    try {
        rows = typeof data.chats === 'string' ? JSON.parse(data.chats) : data.chats;
    } catch (e) {
        rows = data.chats;
    }
    chatUi.renderHistory(rows)
    chatActions.scrollToBottom()
    chatActions.enableInput()

}

export function selectUser(detail) {
    chatActions.setActiveUser(detail)
    
    chatNetwork.getHistory(detail.userId, (history) => {
        chatUi.renderHistory(history)
        chatActions.scrollToBottom()
    })
}

export function getChats(detail) {
    chatNetwork.send(detail, (response) => {
        load(response)
    })
}

export function submit(detail) {
    chatNetwork.send(detail, (response) => {
        load(response)
    })
}

export function typing(detail) {
    if (detail.ev.key === 'Enter') {
        const chatInputElem = detail.ev.target
        const btn = chatInputElem.nextElementSibling
        btn.click()
    }
}

export function receiveMessage(detail) {
    if (chatActions.getCurrentUserId() === detail.fromUserId) {
        chatUi.appendMessage(detail, false)
        chatActions.scrollToBottom()
    } else {
        //
    }
}